import {
  Flex,
  Link,
  Text as ChakraText,
  Tooltip,
  VStack,
} from '@chakra-ui/react'
import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { colors } from '../../../ui-kit'
import { encodeHash } from '../../../utils'
import { addLeadingSlash } from '../../../utils/urlHelpers'
import type { UrlEndpointsResponse } from '../../interfaces'
import { UserContext } from '../../providers'

interface Props {
  urlEndpoint: UrlEndpointsResponse
  path: string
}

const UrlEndpointItem = ({
  urlEndpoint,
  path,
}: Props): React.ReactElement | null => {
  const { user } = useContext(UserContext)

  if (!user) {
    return null
  }

  return (
    <Link
      key={urlEndpoint.id}
      as={NavLink}
      width="full"
      to={`${path}/${encodeHash(urlEndpoint.id)}`}
      _hover={{ textDecoration: 'none', outline: 'none' }}
      _focus={{ textDecoration: 'none', outline: 'none' }}
      _active={{ textDecoration: 'none', outline: 'none' }}
      outline="none"
      activeStyle={{
        background: colors.appPaleGreyThree,
        borderColor: '#e1e4eb',
      }}
      border="1px solid transparent"
      borderRadius="4px"
    >
      <VStack spacing="0.5em" align="left" padding="0.5em" width="full">
        <Tooltip
          label={`${
            urlEndpoint.isDefault
              ? user.baseUrlForClientImageFetch
              : addLeadingSlash(urlEndpoint.urlPrefix)
          } (Click to select)`}
        >
          <ChakraText
            width="full"
            fontSize="md"
            fontWeight="medium"
            color={colors.appDarkIndigo}
            lineHeight="base"
            isTruncated
            userSelect="all"
            cursor="text"
          >
            {urlEndpoint.isDefault
              ? user.baseUrlForClientImageFetch
              : addLeadingSlash(urlEndpoint.urlPrefix)}
          </ChakraText>
        </Tooltip>
        <Tooltip label={`${urlEndpoint.desc} (Click to select)`}>
          <ChakraText
            width="full"
            fontSize="sm"
            lineHeight="base"
            color={colors.appBattleshipGrey}
            isTruncated
            userSelect="all"
            cursor="text"
          >
            {urlEndpoint.desc}
          </ChakraText>
        </Tooltip>
        {urlEndpoint.cnameArr?.length && urlEndpoint.cnameArr.length > 0 && (
          <Flex flexWrap="wrap">
            {urlEndpoint.cnameArr.map((cname, index) => {
              const hostname = new URL(cname).hostname
              return (
                <React.Fragment key={cname}>
                  <Tooltip label={`${hostname} (Click to select)`}>
                    <ChakraText
                      fontSize="sm"
                      color={colors.appBattleshipGrey}
                      lineHeight="base"
                      userSelect="all"
                      cursor="text"
                    >
                      {hostname}
                    </ChakraText>
                  </Tooltip>
                  {index < urlEndpoint.cnameArr.length - 1 && (
                    <ChakraText
                      fontSize="sm"
                      color={colors.appBattleshipGrey}
                      lineHeight="base"
                      userSelect="none"
                      marginRight="4px"
                    >
                      ,
                    </ChakraText>
                  )}
                </React.Fragment>
              )
            })}
          </Flex>
        )}
      </VStack>
    </Link>
  )
}

export default UrlEndpointItem
